export type RouteState<T extends {} = {}> = {
  page: number
  perPage: number
} & T

export const createRouteState = <T extends {}>(
  state: RouteState<T>
): RouteState<T> => state
